import { z } from "zod";
// =============================================================================
// SCHEMAS
// =============================================================================
export const PdfJobStatusSchema = z.enum([
    "pending",
    "processing",
    "waiting_translation",
    "completed",
    "failed",
    "skipped",
]);
export const PdfJobEventSchema = z.object({
    type: z.literal("pdf_job.status_changed"),
    jobId: z.string(),
    status: PdfJobStatusSchema,
    url: z.string().optional(),
    expiresAt: z.string().optional(),
    failureSummary: z.string().optional(),
});
// =============================================================================
// HELPERS
// =============================================================================
export function isTerminalPdfJobStatus(status) {
    return (status === "completed" || status === "failed" || status === "skipped");
}
